import { frontendURL } from '../../../../helper/URLHelper';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import ChannelFactory from './ChannelFactory.vue';

import SettingsContent from '../Wrapper.vue';
import SettingWrapper from '../SettingsWrapper.vue';
import InboxHome from './Index.vue';
import Settings from './Settings.vue';
import InboxChannel from './InboxChannels.vue';
import ChannelList from './ChannelList.vue';
import AddAgents from './AddAgents.vue';
import FinishSetup from './FinishSetup.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/inboxes'),
      component: SettingWrapper,
      children: [
        {
          path: '',
          redirect: to => {
            return { name: 'settings_inbox_list', params: to.params };
          },
        },
        {
          path: 'list',
          name: 'settings_inbox_list',
          component: InboxHome,
          meta: {
            permissions: ['administrator'],
            featureFlag: FEATURE_FLAGS.INBOX_MANAGEMENT,
          },
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/settings/inboxes'),
      component: SettingsContent,
      props: params => {
        const showBackButton = params.name !== 'settings_inbox_list';
        return {
          headerTitle: 'INBOX_MGMT.HEADER',
          headerButtonText: 'SETTINGS.INBOXES.NEW_INBOX',
          icon: 'mail-inbox-all',
          newButtonRoutes: ['settings_inbox_list'],
          showBackButton,
        };
      },
      children: [
        {
          path: 'new',
          component: InboxChannel,
          children: [
            {
              path: '',
              name: 'settings_inbox_new',
              component: ChannelList,
              meta: {
                permissions: ['administrator'],
                showBackButton: true,
                backTo: 'settings_inbox_list',
                featureFlag: FEATURE_FLAGS.INBOX_MANAGEMENT,
              },
            },
            {
              path: ':inbox_id/finish',
              name: 'settings_inbox_finish',
              component: FinishSetup,
              meta: {
                permissions: ['administrator'],
                backTo: 'settings_inbox_list',
                featureFlag: FEATURE_FLAGS.INBOX_MANAGEMENT,
              },
            },
            {
              path: ':sub_page',
              name: 'settings_inboxes_page_channel',
              component: ChannelFactory,
              meta: {
                permissions: ['administrator'],
                backTo: 'settings_inbox_list',
                featureFlag: to => {
                  const map = {
                    facebook: FEATURE_FLAGS.CHANNEL_FACEBOOK,
                    website: FEATURE_FLAGS.CHANNEL_WEBSITE,
                    twitter: FEATURE_FLAGS.CHANNEL_TWITTER,
                    api: FEATURE_FLAGS.CHANNEL_API,
                    email: FEATURE_FLAGS.CHANNEL_EMAIL,
                    sms: FEATURE_FLAGS.CHANNEL_SMS,
                    whatsapp: FEATURE_FLAGS.CHANNEL_WHATSAPP,
                    line: FEATURE_FLAGS.CHANNEL_LINE,
                    telegram: FEATURE_FLAGS.CHANNEL_TELEGRAM,
                    zalooa: FEATURE_FLAGS.CHANNEL_ZALOOA,
                    zalopersonal: FEATURE_FLAGS.CHANNEL_ZALOPERSONAL,
                  };
                  const channelFlag = map[to.params.sub_page];
                  // Require both inbox management and the specific channel flag
                  return channelFlag
                    ? [FEATURE_FLAGS.INBOX_MANAGEMENT, channelFlag]
                    : FEATURE_FLAGS.INBOX_MANAGEMENT;
                },
              },
              props: route => {
                return { channelName: route.params.sub_page };
              },
            },
            {
              path: ':inbox_id/agents',
              name: 'settings_inboxes_add_agents',
              meta: {
                permissions: ['administrator'],
                backTo: 'settings_inbox_list',
                featureFlag: FEATURE_FLAGS.INBOX_MANAGEMENT,
              },
              component: AddAgents,
            },
          ],
        },
        {
          path: ':inboxId',
          name: 'settings_inbox_show',
          component: Settings,
          meta: {
            permissions: ['administrator'],
            noWrapper: true,
            showBackButton: true,
            backTo: 'settings_inbox_list',
            featureFlag: FEATURE_FLAGS.INBOX_MANAGEMENT,
          },
        },
      ],
    },
  ],
};
